import Spacer from '$tablet-app/src/app/components/Spacer';
import { Text } from '@akin-home/text/native';
import { View } from 'react-native';
import styled from 'styled-components/native';
import { ChatItemDialogBody, ChatItemHeader } from '../../ChatItem';
import { ChatClockItem } from '../../ChatItem/types';
import { useDismissChatItemDialog } from '../ChatItemDialog';
import { ChatItemDialogProps } from '../ChatItemDialog/ChatItemDialogProps';

export const TimeChatDialog = (props: ChatItemDialogProps<ChatClockItem>) => {
  const {
    chat_item: {
      data: { location, time, date },
    },
  } = props;

  const onDismiss = useDismissChatItemDialog();

  return (
    <>
      <ChatItemHeader title="clock" icon="clock" onDismiss={onDismiss} />
      <ChatItemDialogBody>
        <BodyContainer>
          <LocationDateView>
            <Text variant="h3" color="white" weight="bold">
              {location}
            </Text>

            <Spacer height="11px" />

            <Text color="white">{date}</Text>
          </LocationDateView>
          <TimeView>
            <TimeText variant="h3" color="white" weight="semibold">
              {time}
            </TimeText>
          </TimeView>
        </BodyContainer>
      </ChatItemDialogBody>
    </>
  );
};

const BodyContainer = styled.View`
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap-reverse;
  width: 100%;
  gap: 20px;
`;

const LocationDateView = styled.View`
  justify-content: center;
`;

const TimeView = styled.View`
  justify-content: center;
`;

const TimeText = styled(Text)`
  font-size: 48px;
  flex-shrink: 1;
  max-width: 100%;
`;
